import { SDUIProductTileImpressionProvider } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/SDUIProductTileImpressionProvider";
import { SDUIComponentInstanceRendererProps } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/types";
import { SDUIGridAutoColumnLayoutBase } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Grid/__internal__/SDUIGridAutoColumnLayoutBase";
import { SDUIGridFixedColumnLayoutBase } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Grid/__internal__/SDUIGridFixedColumnLayoutBase";
import React from "react";

export const SDUIGridRenderer: React.FC<SDUIComponentInstanceRendererProps> = ({
  component,
  loggingData,
  renderBehaviour,
}) => {
  const gridElement = component.grid_component;
  const isRequiredForInteractivity = component.is_required_for_interactivity;

  if (
    !gridElement ||
    !gridElement.column_layout ||
    gridElement.tiles === undefined ||
    gridElement.tiles.length === 0
  ) {
    return null;
  }

  return (
    <SDUIProductTileImpressionProvider loggingData={loggingData}>
      {gridElement.column_layout.auto ? (
        <SDUIGridAutoColumnLayoutBase
          loggingData={loggingData}
          gridComponent={gridElement}
        />
      ) : (
        <SDUIGridFixedColumnLayoutBase
          loggingData={loggingData}
          gridComponent={gridElement}
          isRequiredForInteractivity={isRequiredForInteractivity}
          renderBehaviour={renderBehaviour}
        />
      )}
    </SDUIProductTileImpressionProvider>
  );
};
